import styled from "styled-components";
import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../constants/Styles";

export const BannerContainer = styled.div`
  background-color: ${COLORS.primary};
  display: flex;
  align-items: center;
`;

export const BannerOuterSegment = styled.div`
  flex: 1;
`;

export const Message = styled.div`
  padding: 0.5rem;
  text-align: center;
  font-size: ${FONT_SIZE.size14};
  font-weight: ${FONT_WEIGHT.weight500};
  color: ${COLORS.secondary};

  a {
    color: ${COLORS.secondary};
    &:hover {
      color: ${COLORS.secondary};
    }
  }
`;

export const ClearBanner = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 2rem;
`;
